import React from 'react'
import FirstWeekSurveyForm from './CandidateProgramSurveys/FirstWeekSurveyForm'
import MidProgramSurveyForm from './CandidateProgramSurveys/MidProgramSurveyForm'
import PostProgramSurveyForm from './CandidateProgramSurveys/PostProgramSurveyForm'

export default function CandidateProgramSurveyForm({
  surveyDurationType,
  questions,
  choices,
  candidateId,
  companyId,
  setError,
  setThankYou,
}) {
  if (surveyDurationType === 'firstWeek') {
    return (
      <FirstWeekSurveyForm
        questions={questions}
        choices={choices}
        candidateId={candidateId}
        companyId={companyId}
        setError={setError}
        setThankYou={setThankYou}
      />
    )
  } else if (surveyDurationType === 'midProgram') {
    return (
      <MidProgramSurveyForm
        questions={questions}
        choices={choices}
        candidateId={candidateId}
        companyId={companyId}
        setError={setError}
        setThankYou={setThankYou}
      />
    )
  } else if (surveyDurationType === 'postProgram') {
    return (
      <PostProgramSurveyForm
        questions={questions}
        choices={choices}
        candidateId={candidateId}
        companyId={companyId}
        setError={setError}
        setThankYou={setThankYou}
      />
    )
  } else {
    return null
  }
}
